<template>
  <div>
    <v-select
      ref="selectCategory"
      label="Category"
      :model-value="modelValue"
      no-data-text="No categories setup"
      item-color="button darken-2"
      variant="solo"
      flat
      :clearable="clearable"
      density="comfortable"
      style="border-radius: 5px; font-size: 10pt"
      item-title="name"
      @update:model-value="$emit('update:modelValue', $event)"
      return-object
      :items="categories"
      hide-details=""
      item-props=""
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
      }"
      :menu-props="{ offsetY: true }"
    >
      <template v-slot:item="{ props }">
        <v-list-item v-bind="props" :title="props.name">
          <template v-slot:prepend>
            <v-icon size="15" :color="props.color">mdi-circle</v-icon>
          </template>
        </v-list-item>
      </template>

      <template v-slot:selection="{ item }">
        <div style="font-size: 10pt">
          <v-icon size="15" :color="item.props.color">mdi-circle</v-icon
          >{{ item.props.name }}
        </div>
      </template>

      <!-- <template v-slot:append-item>
        <v-divider></v-divider>
        <div class="d-flex mt-2 px-2 justify-center align-center">
          <NewCategory @new="pickNew" type="list" />
        </div>
      </template> -->
    </v-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import NewCategory from "@/components/NewCategory.vue";

export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: Object, // previously was `value: String`
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // NewCategory,
  },
  computed: {
    ...mapState({
      categories: (state) => state.posts.categories,
      loading: (state) => state.loading,
    }),
  },
  methods: {
    sync(v) {
      this.$emit("update:category", v);
      this.$emit("input", v);
    },
    pickNew(uid) {
      let v = this.categories.find((i) => i.uid === uid);
      this.$emit("update:category", v);
      this.$emit("input", v);
    },
  },
};
</script>
